module.exports = "<div data-ui-view></div>";